/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Entry/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Entry({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/PaymentOverdue/Content/Entry"
  
}) {
let entryDueNowValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'due_now',
format: fromFormat.numberMoney,
})
let constantData = ' for '
let entryPaymentAccountValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'payment_account',
format: fromHelpers.getPayorName,
})
let constantData1 = '.'
let aggregateData = fromAggregate.joinNoSpace(entryDueNowValueData, constantData, entryPaymentAccountValueData, constantData1)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="entry.due_now"
 format="/Data/format.js numberMoney"
 data="' for '"
 data="entry.payment_account"
 format="helpers.js getPayorName"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}